import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { CustomSnackbarComponent } from 'src/app/___COMPONENTS/__common/custom-snackbar/custom-snackbar.component';

@Injectable({
  providedIn: 'root'
})
export class GuiFlowService {

  bottomBar = {
    home: [
      {
        label: 'Discover',
        icon: 'sparkles',
        route: 'home'
      },
      {
        label: 'Apps',
        icon: 'square_grid_2x2_fill',
        route: 'apps'
      },
      {
        label: 'Profile',
        icon: 'person_fill',
        route: 'profile'
      },
    ],
    orders: [
      {
        label: 'Discover',
        icon: 'sparkles',
        route: 'home'
      },
      {
        label: 'Apps',
        icon: 'square_grid_2x2_fill',
        route: 'apps'
      },
      {
        label: 'Profile',
        icon: 'person_fill',
        route: 'profile'
      },
    ]
  };

  spinnerModalConfig = {
    loadingModal: false,
    modalType: null,
    message: null,
    confirmationText: null
  }

  constructor(private _snackBar: MatSnackBar,public dialog: MatDialog,private route: Router) { }

  showSpinnerModal(message?: string){
    this.spinnerModalConfig.loadingModal = true;
    this.spinnerModalConfig.modalType = 'loading';
    this.spinnerModalConfig.message = message;
  }

  showPaymentReceivedModal(message){
    this.spinnerModalConfig.modalType = 'confirmation';
    this.spinnerModalConfig.loadingModal = true;
    this.spinnerModalConfig.message = message;
  }

  hideModal(){
    this.spinnerModalConfig.loadingModal = false;
  }

  getModalInfo(prop){
    return this.spinnerModalConfig[prop];
  }

  isLoadingModalVisible(){
    return this.spinnerModalConfig.loadingModal;
  }

  getConfirmationText(){
    return this.spinnerModalConfig.confirmationText;
  }
  
  // ---------------------------
  // SNACKBAR AND ALERTS

  openSimpleSnackBar(message: string, type: 'success' | 'error' | 'warning' | 'info' = 'info', duration?: number,action: string = 'Ok') {
    const effectiveDuration = duration !== null ? duration : 4000;
    this._snackBar.openFromComponent(CustomSnackbarComponent, {
      data: { message, type,action,duration:effectiveDuration },
      duration:effectiveDuration,
      panelClass: ['no-padding'], // Para eliminar padding por defecto,
    });
  }

  reportError(error,trace){
    if(error && error.KO && error.KO.message){
      this.openSimpleSnackBar(error.KO.message,'error');
    }else{
      if(error){
        this.openSimpleSnackBar(error,'error',null,'Ok');
      }else{
        this.openSimpleSnackBar('❌ '+'Error: check console for details','error',null,'Ok');
      }
    }
    trace? console.log('BACKEND Error:' +trace) : console.log(error);
  }

  reportSuccess(msg){
    this.openSimpleSnackBar(msg,'success');
  }

  getImage(imageId,variant){
    variant? variant : variant = 'public';
    return 'https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/'+imageId+'/'+variant;
  }

  getWorkerImage(imageName,variant){
    return 'https://voyjaleas-website.sebtec12.workers.dev/'+imageName;
  }

  getBarButtons(route){
    let label;
    if(route == '/' || route == '/home'){
      label = 'home'
    } else
    if(route == '/orders' ){
      label = 'orders';
    }
    if(route == '/apps' ){
      label = 'home';
    }
    return this.bottomBar[label];
  }

  goToHome(){
    this.route.navigateByUrl('home');
  }

  goToLogin(){
    this.route.navigateByUrl('login');
  }

  goToLogOut(){
    this.route.navigateByUrl('loading');
  }

}
